import { manageAchat } from "Achat/Store/reducers";
import { manageToken, manageUser, manageVersion } from "App/Authentification/Store/reducers";
import { manageHeader } from "App/Header/Store/reducers";
import { manageLoading } from "App/Loading/Store/reducers";
import { createStore } from "redux";
import { persistCombineReducers, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { manageReferentiel } from "Referentiel/Store/reducers";
import { manageDataResource } from "Request/Store/reducers";
import { manageGeolocationBlocked } from "./Geolocation/reducers";

const rootPersistConfig = {
  key: "alt-ekip-store",
  storage: storage
};

export const store = createStore(
  persistCombineReducers(rootPersistConfig, {
    manageAchat,
    manageDataResource,
    manageGeolocationBlocked,
    manageHeader,
    manageLoading,
    manageReferentiel,
    manageToken,
    manageUser,
    manageVersion
  })
);

export const persistor = persistStore(store);
